module.exports = __webpack_public_path__ + "img/getting-started.87039aa2.jpg";